import { IEdp } from '../IProduct';
import { StyleAndSize } from '../ProductCard/ProductCard';

export class ProductHelpers {
    public static isSizeDisabled(
        i: number,
        styleIndex: number,
        edps: IEdp[],
        styles: StyleAndSize[],
        sizes: StyleAndSize[],
    ): boolean {
        // If no style option available, only consider sizes
        // Find the edp by size and check the inventory field
        if (!styles || styles?.length === 0) {
            const edp = edps.find((edpItem) => {
                return sizes[i] && sizes[i].DimensionId === edpItem.SizeDimensionId;
            });

            if (!edp) {
                return true;
            }

            return edp.Inventory === 0;
        }

        // At this point, there is at least one style value
        // First check the style index
        // If no style option is selected, check edps with only size
        if (styleIndex === -1) {
            const filtered = edps.filter((edpItem) => {
                return sizes[i] && sizes[i].DimensionId === edpItem.SizeDimensionId;
            });

            return filtered.every((item) => item.Inventory === 0);
        }

        const edp = edps.find((edpItem) => {
            return (
                styles[styleIndex] &&
                sizes[i] &&
                styles[styleIndex].DimensionId === edpItem.StyleDimensionId &&
                sizes[i].DimensionId === edpItem.SizeDimensionId
            );
        });

        if (!edp) {
            return true;
        }

        return edp.Inventory === 0;
    }

    // returns disabled only if style in currently selected size is sold out   -used on PRP
    public static isStyleDisabled(
        i: number,
        selectedSizeIndex: number,
        edps: IEdp[],
        styles: StyleAndSize[],
        sizes: StyleAndSize[],
    ): boolean {
        // If no size option available, only consider styles
        // Find the edp by style, and check the inventory field
        if (!sizes || sizes?.length === 0) {
            const edp = edps.find((edpItem) => {
                return styles[i] && styles[i].DimensionId === edpItem.StyleDimensionId;
            });

            if (!edp) {
                return true;
            }

            return edp.Inventory === 0;
        }

        // At this point, there is at least one size value exists
        // First check the size index
        // If no size option is selected, check only with style
        if (selectedSizeIndex === -1) {
            const filtered = edps.filter((edpItem) => {
                return styles[i] && styles[i].DimensionId === edpItem.StyleDimensionId;
            });

            return filtered.every((item) => item.Inventory === 0);
        }

        const edp = edps.find((edpItem) => {
            return (
                sizes[selectedSizeIndex] &&
                styles[i] &&
                sizes[selectedSizeIndex].DimensionId === edpItem.SizeDimensionId &&
                styles[i].DimensionId === edpItem.StyleDimensionId
            );
        });

        if (!edp) {
            return true;
        }

        return edp.Inventory === 0;
    }
    // returns size disabled
    public static isSizeDisabledV2(
        i: number,
        styleIndex: number,
        edps: IEdp[],
        styles: StyleAndSize[],
        sizes: StyleAndSize[],
    ): boolean {
        // If no style option available, only consider sizes
        // Find the edp by size and check the inventory field
        if (!styles || styles?.length === 0) {
            const edp = edps.find((edpItem) => {
                return sizes[i] && sizes[i].DimensionId === edpItem.SizeDimensionId;
            });

            if (!edp) {
                return true;
            }

            return edp.Inventory <= 0;
        }

        // At this point, there is at least one style value
        // First check the style index
        // If no style option is selected, check edps with only size
        if (styleIndex === -1) {
            const filtered = edps.filter((edpItem) => {
                return sizes[i] && sizes[i].DimensionId === edpItem.SizeDimensionId;
            });

            return filtered.every((item) => item.Inventory <= 0);
        }

        const edp = edps.find((edpItem) => {
            return (
                styles[styleIndex] &&
                sizes[i] &&
                styles[styleIndex].DimensionId === edpItem.StyleDimensionId &&
                sizes[i].DimensionId === edpItem.SizeDimensionId
            );
        });

        if (!edp) {
            return true;
        }

        return edp.Inventory <= 0;
    }

    // this returns style disabled only if style in every size is sold out   -used on PDP
    public static isStyleDisabledV2(
        i: number,
        selectedSizeIndex: number,
        edps: IEdp[],
        styles: StyleAndSize[],
        sizes: StyleAndSize[],
    ): boolean {
        // If no size option available, only consider styles
        // Find the edp by style, and check the inventory field
        if (!sizes || sizes?.length === 0) {
            const edp = edps.find((edpItem) => {
                return styles[i] && styles[i].DimensionId === edpItem.StyleDimensionId;
            });

            if (!edp) {
                return true;
            }

            return edp.Inventory <= 0;
        }

        // multiple sizes of this style exists
        // check if its sold out in all sizes, return true if all sold out

        const filtered = edps.filter((edpItem) => {
            return styles[i] && styles[i].DimensionId === edpItem.StyleDimensionId;
        });

        return filtered.every((item) => item.Inventory <= 0);
    }
}
